<template>
  <div style="padding:10px">
    <van-field  v-model="search"  background="#f0f0f0" placeholder="Müşteri ara"/>

    <!-- <van-pull-refresh id="tablo" v-model="pullrefresh" @refresh="getir"> -->
      <van-swipe-cell v-for="(post,index) in filteredList" :key="index" >
        <!-- <template #left> :label="$helper.ilkharfBuyuk(post.bolge).substring(0, 50) +' '+post.bakiye+''+hesap.pb"
          <van-button square type="primary" text="Detay" />
        </template> -->
        <van-cell @click="cariSec(post)" :value="post.bakiye+''+hesap.pb" :title="$helper.ilkharfBuyuk(post.unvan).substring(0, 80)"  icon="cluster-o" style="padding-left:5px">

  </van-cell>
    </van-swipe-cell>
  <!-- </van-pull-refresh> -->


  </div>
</template>

<script>
export default {
  data() {
    return {
      hesap:this.$store.getters.getHesap,
      pullrefresh : false,

      obj: {
        pkod:this.$store.getters.getHesap.entegrekodu,
        ckod:0,
        search: null,
        sayfa: 1,
        toplam: 0,
      },
      mesaj : '',
      search:''
    };
  },
  computed:{
  
  },
  created(){
    this.$store.commit("setLoading",[false,'...'])
  },
  computed:{
    filteredList() {
      return this.$store.getters.getCari.liste.filter(post => {
        return post.unvan.toLowerCase().includes(this.search.toLowerCase())
      })
    }    
  },
methods:{
  getir() {
      this.$store.commit("setLoading",[true,'Cari yükleniyor'])
        this.$store.dispatch('carilist',this.$request).then((cari) => {
          this.pullrefresh = false
          this.$store.commit("setLoading",[false,'...'])
            }).catch((err)=>{
              this.pullrefresh = false
              this.$store.commit("setLoading",[false,'...'])
              this.$notify({ type: 'danger', message: err.mesaj });
            })
    },
    cariSec(post) {
      this.$store.dispatch('setCari' , {data:post,nereye:'aktif'})
      this.$notify({ type: 'success', message: 'Başarılı' });
    }
}
};
</script>
<style scoped>
.van-cell__left-icon{
  font-size:18px !important
}
.van-cell__value {
  width:30% !important
};
.van-cell__title {
  width:70% !important
}
</style>


// WEBPACK FOOTER //
// src/views/cari.vue